import { styled } from "goober";
import { createPortal } from "react-dom";
import { zIndexes } from "../../lib/zIndexes";
import { AnchoredPopover } from "../AnchoredPopover";
import { ClickButton } from "../ClickButton";
import { Icon } from "../Icon";

const Bubble = styled(ClickButton)`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 8px;
  background: var(--tooltip-bg);
  color: var(--tooltip-fg);
  border: none;
  border-radius: 12px;
  box-shadow: var(--elevation-low);
  font-size: 10px;
  font-family: inherit;
  cursor: pointer;
  position: relative;

  &::before {
    content: "";
    position: absolute;
    bottom: -3px;
    left: 50%;
    width: 8px;
    height: 8px;
    background: var(--tooltip-bg);
    transform: translateX(-50%) rotate(45deg);
    clip-path: polygon(100% 0, 100% 100%, 0 100%);
  }
`;

type Rect = { top: number; left: number; width: number; height: number };

type Props = {
  rect: Rect | null;
  editorEl: HTMLElement | null;
  onClick?: () => void;
};

export function SelectionTooltip({ rect, editorEl, onClick }: Props) {
  const popoverStyle: React.CSSProperties = {
    bottom: "anchor(top)",
    left: "anchor(center)",
    translate: "-50% 0",
    marginBottom: "8px",
    background: "transparent",
    boxShadow: "none",
    zIndex: zIndexes.tooltip,
  };

  return (
    <AnchoredPopover
      isOpen={!!rect && !!editorEl}
      trigger={({ style }) =>
        editorEl
          ? createPortal(
              <div
                style={{
                  position: "absolute",
                  top: rect?.top ?? 0,
                  left: rect?.left ?? 0,
                  width: rect?.width ?? 0,
                  height: rect?.height ?? 0,
                  pointerEvents: "none",
                  ...style,
                }}
              />,
              editorEl
            )
          : null
      }
      style={popoverStyle}
    >
      <Bubble
        onMouseDown={(e) => {
          e.preventDefault();
          e.stopPropagation();
        }}
        onClick={onClick}
      >
        Add to chat
        <Icon name="corner-down-left" size={10} color="var(--text-secondary)" />
      </Bubble>
    </AnchoredPopover>
  );
}
